import { render, staticRenderFns } from "./brief-introduction.vue?vue&type=template&id=d3caffb0&scoped=true&"
import script from "./brief-introduction.vue?vue&type=script&lang=js&"
export * from "./brief-introduction.vue?vue&type=script&lang=js&"
import style0 from "./brief-introduction.vue?vue&type=style&index=0&id=d3caffb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3caffb0",
  null
  
)

export default component.exports